import {useLocation, Navigate} from 'react-router-dom'
import { useContext } from "react";
import { AuthContext } from "../context/authContext";
 

const RequireAdmin = ({children}: {children: React.ReactElement}) => {
    const location = useLocation()
    const {currentUser, checkLocalUser} : any = useContext(AuthContext);
   
    checkLocalUser()
    if(currentUser)
    {
        
        if(currentUser.admin !== 1 && currentUser.admin !==2 ) return <Navigate to="/test" state={{from: location}}/>
        return children
    }

    return <Navigate to="/login" state={{from: location}}/>
    

    
}


export default RequireAdmin